import axios from "axios";
import { apiRoot } from "../../index";
import moment from "moment-timezone";
import { startLoading, stopLoading } from "../loader";

export async function createBooking(jwt, booking) {
  startLoading();

  booking.name = `${booking.firstname} ${booking.lastname} (${moment(
    booking.date * 1000
  ).format("DD-MM-YYYY")} at ${booking.time})`;

  const res = await axios.post(
    apiRoot + "/api/v1/dispatch/create-booking",
    {
      booking,
    },
    {
      headers: {
        authorization: jwt,
      },
    }
  );

  stopLoading();

  return res.data;
}

export async function updateBooking(jwt, booking) {
  startLoading();

  const res = await axios.post(
    apiRoot + "/api/v1/dispatch/update-booking",
    {
      booking,
    },
    {
      headers: {
        authorization: jwt,
      },
    }
  );

  stopLoading();

  return res.data;
}

export async function generateTrackTokens(jwt, bookingId) {
  startLoading();

  const res = await axios.get(
    apiRoot + "/api/v1/driverapp/generate-tokens/" + bookingId,
    {
      headers: {
        authorization: jwt,
      },
    }
  );

  stopLoading();

  return res.data;
}

export async function deleteBooking(jwt, booking_id) {
  if (!(booking_id instanceof Array)) {
    booking_id = [booking_id];
  }

  startLoading();

  const res = await axios.post(
    apiRoot + "/api/v1/dispatch/delete-booking",
    { bookingIdList: booking_id },
    {
      headers: {
        authorization: jwt,
      },
    }
  );

  stopLoading();

  return res.data;
}

export async function unsetBookingsDriver(jwt, booking_id) {
  if (!(booking_id instanceof Array)) {
    booking_id = [booking_id];
  }

  startLoading();

  const res = await axios.post(
    apiRoot + "/api/v1/dispatch/unset-driver-booking",
    { bookingIdList: booking_id },
    {
      headers: {
        authorization: jwt,
      },
    }
  );

  stopLoading();

  return res.data;
}

export async function duplicateBooking(jwt, booking_id) {
  if (!(booking_id instanceof Array)) {
    booking_id = [booking_id];
  }

  startLoading();

  const res = await axios.post(
    apiRoot + "/api/v1/dispatch/duplicate-booking",
    { bookingIdList: booking_id },
    {
      headers: {
        authorization: jwt,
      },
    }
  );

  stopLoading();

  return res.data;
}

export async function getBookingPrice(
  jwt,
  pickupAddress,
  dropoffAddress,
  bookingType,
  numHours,
  vehicle,
  tarifId,
  productId = null,
  pickupPlaceId = null,
  dropoffPlaceId = null,
  pickupCoords = null,
  dropoffCoords = null
) {
  try {
    const response = await axios.post(
      apiRoot + "/api/v1/dispatch/booking/prices",
      {
        pickupAddress,
        dropoffAddress,
        bookingType,
        numHours,
        vehicle,
        tarifId,
        productId,
        pickupPlaceId,
        dropoffPlaceId,
        // Include coordinates if available
        ...(pickupCoords && pickupCoords.lat && pickupCoords.lon && {
          pickupLat: pickupCoords.lat,
          pickupLon: pickupCoords.lon
        }),
        ...(dropoffCoords && dropoffCoords.lat && dropoffCoords.lon && {
          dropoffLat: dropoffCoords.lat,
          dropoffLon: dropoffCoords.lon
        })
      },
      {
        headers: {
          Authorization: jwt,
        },
      }
    );

    return (
      response.data?.price || {
        partner: 0,
        client: 0,
        distance: 0,
        duration: 0,
      }
    );
  } catch (e) {
    console.error("ERROR WHEN FETCHING BOOKING PRICES\nError: ", e);
    return { partner: 0, client: 0, distance: 0, duration: 0 };
  }
}
